/** Shown on client dashboard when risk controls are locked (first 30 days). */
export const FIRST_MONTH_RISK_NOTICE =
  "You are not authorized to change risk management during the first month.";
